<template>
    <AppPage :check-user-permission="false">
        <div class="title is-2">Você realmente deseja sair do sistema?</div>
        <b-button type="is-danger" @click="logout">Sair</b-button>
    </AppPage>
</template>

<script>
    import AppPage from "@/components/AppPage";
    export default {
        name: "userSignOutPage",
        components: {AppPage},
        
        methods: {
            logout(){
                this.$store.dispatch('userLogout');
                this.$router.push({name: 'home'});
            }
        }
    }
</script>
